module.exports = __webpack_public_path__ + "img/idex.07095ea7.png";